package ru.it_mozaika.sender.js.application.components.triggers.categories

import mui.material.*
import mui.system.responsive
import mui.system.sx
import react.*
import react.dom.onChange
import ru.it_mozaika.sender.common.models.TriggerCategory
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.sender.js.application.components.StoresSelect
import ru.it_mozaika.sender.js.application.context.RequestResultContext
import ru.it_mozaika.sender.js.application.context.StoreContext
import web.cssom.AlignItems
import web.cssom.px
import web.html.HTMLInputElement
import web.html.InputType

external interface TriggersCategoryDialogProps: Props {
    var isOpen: Boolean
    var selected: TriggerCategory?
    var onClose: () -> Unit
}

val triggersCategoryDialog = FC<TriggersCategoryDialogProps> { props ->

    val (name, setName) = useState<String>()
    val (mailsLimit, setMailsLimit) = useState<Int>()
    val (limitPeriod, setLimitPeriod) = useState<Long>()
    val storeContext = useContext(StoreContext)
    val (isDisabled, setIsDisabled) = useState(false)
    val requestResult = useContext(RequestResultContext)
    useEffect(props.selected){
        if (props.selected != null) {
            setIsDisabled(true)
            setName(props.selected!!.name)
            setMailsLimit(props.selected!!.mailsLimit)
            setLimitPeriod(props.selected!!.limitPeriod)
            storeContext.setStore(props.selected!!.store)
        } else {
            setIsDisabled(false)
            setName(null)
            setMailsLimit(null)
            setLimitPeriod(null)
        }
    }

    Dialog {
        this.open = props.isOpen
        DialogTitle {
            if (props.selected == null) {
                + "Создание новой категории"
            } else {
                +  "Редактирование категории"
            }
        }
        DialogContent {
            Stack {
                sx {
                    paddingTop = 5.px
                }
                direction = responsive(StackDirection.column)
                this.spacing = responsive(2)
                TextField {
                    disabled = isDisabled
                    value = name ?: ""
                    sx {
                        minWidth = 200.px
                        height = 50.px
                    }
                    id = "trigger-category-name-field"
                    label = ReactNode("Наименование:")
                    required = true
                    type = InputType.text
                    fullWidth = true
                    error = name.isNullOrBlank()
                    variant = FormControlVariant.outlined
                    this.onChange = { event ->
                        val newValue = (event.target as? HTMLInputElement)?.value.orEmpty()
                        setName(newValue)
                    }
                }
                StoresSelect{
                    disabled = isDisabled
                }
                TextField {
                    disabled = isDisabled
                    value = mailsLimit ?: 0
                    sx {
                        minWidth = 200.px
                        height = 50.px
                    }
                    id = "trigger-category-email-limit-field"
                    label = ReactNode("Ограничение кол-ва писем:")
                    required = true
                    type = InputType.number
                    fullWidth = true
                    variant = FormControlVariant.outlined
                    this.onChange = { event ->
                        val newValue = (event.target as? HTMLInputElement)?.value.orEmpty()
                        setMailsLimit(newValue.toInt())
                    }
                }
                TextField {
                    disabled = isDisabled
                    value = limitPeriod ?: 0
                    sx {
                        minWidth = 200.px
                        height = 50.px
                    }
                    id = "trigger-category-limit-period-field"
                    label = ReactNode("Период ограничения:")
                    required = true
                    type = InputType.number
                    fullWidth = true
                    variant = FormControlVariant.outlined
                    this.onChange = { event ->
                        val newValue = (event.target as? HTMLInputElement)?.value.orEmpty()
                        setLimitPeriod(newValue.toLong())
                    }
                }
            }
        }
        DialogActions {
            Stack {
                sx{
                    alignItems = AlignItems.flexEnd
                }
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Button {
                    disabled = name.isNullOrBlank() || storeContext.currentStore == null || limitPeriod == null || mailsLimit == null
                    color = ButtonColor.secondary
                    if (props.selected == null) {
                        + "Создать"
                    } else {
                        + if (isDisabled) "Редактировать" else "Сохранить изменения"
                    }
                    variant = ButtonVariant.outlined
                    this.onClick = {
                        if (props.selected == null ) {
                            if(!name.isNullOrBlank() && storeContext.currentStoreId != null && mailsLimit != null && limitPeriod != null) {
                                Http.put(
                                    "/triggers/categories",
                                    TriggerCategory("", name, storeContext.currentStoreId!!, mailsLimit, limitPeriod)
                                ) { response ->
                                    requestResult.handleRequestRespond(response)
                                    props.onClose()
                                }
                            }
                        } else {
                            if (isDisabled){
                                setIsDisabled(false)
                            } else {
                                if(!name.isNullOrBlank() && storeContext.currentStoreId != null && mailsLimit != null && limitPeriod != null) {
                                    Http.post(
                                        "/triggers/categories",
                                        TriggerCategory(props.selected!!.id, name, storeContext.currentStoreId!!, mailsLimit, limitPeriod)
                                    ) { response ->
                                        requestResult.handleRequestRespond(response)
                                        props.onClose()
                                    }
                                }
                            }
                        }
                    }
                }
                Button {
                    +  "Отмена"
                    color = ButtonColor.error
                    onClick = {
                        props.onClose()
                    }
                    variant = ButtonVariant.outlined
                }
            }
        }
    }
}